<template>
  <div class="aboutTechnical">
    <div class="aboutTechnical-header animate__animated animate__backInLeft">
      <img :src="topImg" :alt="$i18n.locale === 'en-US' ? 'GZZHYUN technical resources banner' : '智会云技术文档横幅'">
    </div>
    <div class="aboutTechnical-center">
      <div class="title animate__animated animate__fadeInDown animate__delay-1s">
        <!-- <div class="title-English"><span style="margin-right:20px">TECHNICAL</span><span>DOCUMENTS</span></div> -->
        <div>{{$t('technical.technical')}}</div>
      </div>
    </div>
    <div class="aboutTechnical-introduce">
        <div class="aboutTechnical-box">
            <div class="aboutTechnical-box-item" v-for="(item,index) in filesList" :key="index">
                <div v-if="(index + 2)%2 == 0" class="wow animate__animated animate__fadeInDown" data-wow-delay="0.5s" data-wow-duration="1.5s" style="width: 100%;height: 100%;overflow: hidden;border-radius: 18px;">
                    <div class="doc-title">{{item.docTitle}}</div>
                    <div class="doc-desc">{{item.docDesc}}</div>
                    <div class="download-btn" @click="downloadFile(item)"><span><i class="el-icon-download"></i></span>{{$t('technical.download')}}</div>
                </div>
                <div v-if="(index + 2)%2 != 0" class="wow animate__animated animate__fadeInUp" data-wow-delay="0.5s" data-wow-duration="1.5s" style="width: 100%;height: 100%;overflow: hidden;border-radius: 18px;">
                    <div class="doc-title">{{item.docTitle}}</div>
                    <div class="doc-desc">{{item.docDesc}}</div>
                    <div class="download-btn" @click="downloadFile(item)"><span><i class="el-icon-download"></i></span>{{$t('technical.download')}}</div>
                </div>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryFilesInfo.pageNum"
                :page-sizes="[9, 18, 27, 54]"
                :page-size="queryFilesInfo.pageSize"
                layout="pager"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import { getWebTopBackground, getTechnicalList, downloadFile } from '@/api/editTechnical'
export default {
  data () {
    return {
      topImg: '', // 顶部图片
      // 获取技术文档列表的参数对象
      queryFilesInfo: {
        pageNum: 1, // 当前的页数
        pageSize: 9 // 当前显示的多少条数据
      },
      // 技术文档列表
      filesList: [],
      // 总条数
      total: 0
    }
  },
  async mounted () {
    document.documentElement.scrollTop = 0
    await this.getTopBackground()
    this.getTechnicalFilesList()
  },
  methods: {
    // 获取顶部图片
    getTopBackground () {
      getWebTopBackground().then(res => {
        if (res.code == 0) {
          this.topImg = res.data.value
        }
      })
    },
    // 获取技术文档列表
    getTechnicalFilesList () {
      this.filesList = []
      getTechnicalList(this.queryFilesInfo).then(res => {
        if (res.code == 0) {
          this.filesList = res.data.rows
          this.total = res.data.total
          this.refreshWow()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    refreshWow () {
      this.$nextTick(() => {
        if (this.$wow && this.$wow.element && typeof this.$wow.sync === 'function') {
          this.$wow.sync()
        } else if (this.$wow && typeof this.$wow.init === 'function') {
          this.$wow.init()
        }
      })
    },
    // 下载技术文档文件
    downloadFile (item) {
      const downloadPath = item && item.downloadPath
      if (!downloadPath) {
        return
      }
      downloadFile(downloadPath).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', item.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      })
    },
    // 分页功能下拉选择器触发
    handleSizeChange (newSize) {
      this.queryFilesInfo.pageSize = newSize
      this.getTechnicalFilesList()
    },
    // 监听页码值改变
    handleCurrentChange (newSize) {
      this.filesList = []
      this.queryFilesInfo.pageNum = newSize
      this.getTechnicalFilesList()
    }
  }
}
</script>

<style lang="less" scoped>
.aboutTechnical{
    min-height: 600px;
    .aboutTechnical-header{
        width: 100%;
        img{
            width: 100%;
            height: auto;
            display: block;
        }
    }
    .aboutTechnical-center{
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 35px;
        .title{
            text-align: center;
            font-size: 26px;
            color: black;
            letter-spacing: 5px;
            line-height: 40px;
            margin-bottom: 30px;
            .title-English{
                font-family: cursive;
            }
        }
    }
    .aboutTechnical-introduce{
        max-width: 1200px;
        padding: 0 24px;
        box-sizing: border-box;
        margin: 45px auto 40px;

        .aboutTechnical-box {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 24px;

            .aboutTechnical-box-item {
                width: 100%;
                min-height: 210px;
                border-radius: 18px;
                background: #f8f9fb;
                box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);

                > div {
                    width: 100%;
                    height: 100%;
                    padding: 24px 20px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    border-radius: 18px;
                    background: #ffffff;
                    border: 1px solid #ebedf0;
                }

                .doc-title {
                    font-size: 22px;
                    font-weight: 600;
                    color: #222;
                    line-height: 1.5;
                    word-break: break-word;
                    margin-bottom: 16px;
                    overflow: hidden;
                    display: -webkit-box;
                    line-clamp: 2;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                .doc-desc {
                    color: #666;
                    font-size: 15px;
                    line-height: 1.8;
                    word-break: break-word;
                    flex: 1;
                    margin-bottom: 20px;
                    overflow: hidden;
                    display: -webkit-box;
                    line-clamp: 5;
                    -webkit-line-clamp: 5;
                    -webkit-box-orient: vertical;
                }

                .download-btn {
                    width: 100%;
                    padding: 10px 16px;
                    border-radius: 10px;
                    background: #1677ff;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    user-select: none;
                    text-align: center;
                    span {
                        font-size: 20px;
                        margin-right: 5px;
                    }

                    &:hover {
                        background: #0958d9;
                        transform: translateY(-1px);
                    }
                }
            }
        }
    }
    .pagination{
        display: flex;
        justify-content: center;
        margin-top: 10px;
    }
}

@media (max-width: 1199.98px) {
    .aboutTechnical {
        .aboutTechnical-center,
        .aboutTechnical-introduce {
            padding: 0 15px;
        }

        .aboutTechnical-introduce {
            .aboutTechnical-box {
                gap: 20px;
            }
        }
  }
}

@media (max-width: 991.98px) {
    .aboutTechnical {
        .aboutTechnical-introduce {
            .aboutTechnical-box {
                grid-template-columns: repeat(2, minmax(0, 1fr));

                .aboutTechnical-box-item {
                    min-height: 220px;

                    .doc-title {
                        font-size: 20px;
                    }
                }
            }
        }
    }
}

@media (max-width: 767.98px) {
  .aboutTechnical {
    .aboutTechnical-center {
      margin-top: 20px;

      .title {
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 2px;
        margin-bottom: 20px;

        .title-English {
          font-size: 14px;
          word-break: break-word;
        }
      }
    }

        .aboutTechnical-introduce {
            padding: 0 12px;
            margin: 24px auto 30px;

            .aboutTechnical-box {
                grid-template-columns: 1fr;
                gap: 14px;

                .aboutTechnical-box-item {
                    min-height: 0;

                    > div {
                        padding: 18px 16px;
                    }

                    .doc-title {
                        font-size: 18px;
                        margin-bottom: 10px;
                    }

                    .doc-desc {
                        font-size: 14px;
                        line-height: 1.7;
                        margin-bottom: 16px;
                        line-clamp: 5;
                        -webkit-line-clamp: 5;
                    }

                    .download-btn {
                        width: 100%;
                        min-width: 0;
                        text-align: center;
                        padding: 10px 14px;
                    }
                }
            }
        }

        .pagination {
            margin-top: 20px;
        }
  }
}
</style>
